import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IconType } from 'shared/icons/SvgIcon';
import { mergeClasses } from 'shared/utils/mergeClasses';

interface MenuItemProps {
  label: string;
  href: string;
  icon: IconType;
  active?: boolean;
  onClick?: () => void;
  className?: string;
  count?: number;
}

export const MenuItem: FC<MenuItemProps> = ({
  label,
  href,
  icon: Icon,
  active,
  onClick,
  className = '',
  count,
}) => {
  return (
    <li
      className={mergeClasses(
        'rounded-lg transition-all',
        active ? 'bg-white/10 shadow-sm-primary lg:bg-transparent lg:shadow-none' : '',
        className,
      )}
    >
      <Link
        onClick={onClick}
        to={href}
        className="flex items-center justify-between gap-2 border-y border-transparent px-3 py-[7px] font-medium transition-all lg:justify-center lg:p-0"
      >
        <div
          className={mergeClasses(
            'flex items-center gap-2 lg:flex-col lg:gap-1',
            active
              ? 'text-white lg:text-black [&>div]:bg-primary [&>div]:text-white lg:[&>div]:shadow-[-1px_2px_8px_0px_rgba(148,148,148,0.80)] [&>span]:text-white'
              : 'text-gray-400 lg:text-gray',
          )}
        >
          <div className="flex-center relative h-6.5 w-6.5 rounded-full transition-all lg:h-10 lg:w-10 lg:bg-white">
            <Icon className="h-4 w-4 lg:h-5 lg:w-5" />
            {!!count && (
              <span className="absolute -bottom-1 -right-1 hidden min-w-[20px] items-center justify-center rounded-xl border border-primary bg-primary p-0.5 text-xxs font-medium text-white lg:flex">
                {count}
              </span>
            )}
          </div>
          <span className="text-left text-gray-400 lg:text-center lg:text-xs lg:!text-gray">
            {label}
          </span>
          {!!count && (
            <span className="flex-center min-w-[20px] rounded-xl border border-primary bg-white p-0.5 text-xxs font-medium text-primary lg:hidden">
              {count}
            </span>
          )}
        </div>
      </Link>
    </li>
  );
};
